import MembershipController from "../controllers/MembershipController"
import MembershipSummaryViewModel from '../models/membership/MembershipSummaryViewModel';
import { useState } from 'react';
import { MemberViewModel } from "../models/member/MemberViewModel";
import moment from 'moment'
import MemberController from "../controllers/MemberController";


export default function MemberList() {
    const [membershipSummary, setMembershipSummary] = useState<MembershipSummaryViewModel | undefined>();
    const [currentMember, setCurrentMember] = useState<MemberViewModel | undefined>();
    const [dateOfBirth, setDateOfBirth] = useState<string>("");
    const [surname, setSurname] = useState<string>("");
    const [members, setMembers] = useState<MemberViewModel[] | null>()
    const membershipController = new MembershipController();
    const memberController = new MemberController();

    const getMembershipSummary = async () => {
        var result = await membershipController.GetMembershipSummary();
        if (result) {
            setMembershipSummary(result)
        }
    }

    const setMember = async (member: MemberViewModel) => {
        if (member.Id) {
            var result = await memberController.GetMemberById({ Id: member.Id });
            if (result) {
                setCurrentMember(result)
            }
        }
    }

    const membershipDue = (dueDate: Date | undefined) => {
        if (dueDate) {
            if (moment(dueDate) > moment(new Date())) {
                return false;
            }
            return true;
        }
        return true;
    }


    if (!membershipSummary) {
        getMembershipSummary();
    }

    const handleDateChange = async (e: any) => {
        var date = e.target.value;
        setDateOfBirth(date)
        if (date && moment(date, "yyyy-MM-dd").isValid()) {
            var results = await memberController.SearchMembers(date, surname);
            setMembers(results);
        }
    }

    const handleSurnameChange = async (e: any) => {
        var surname = e.target.value;
        setSurname(surname)
        var results = await memberController.SearchMembers(dateOfBirth, surname);
        setMembers(results);
    }


    const addNote = async (memberId: string | undefined) => {
        if (memberId && currentMember) {
            var note = prompt("Please enter your note")
            if (note) {
                await memberController.AddNoteToMember({ MemberId: memberId, Note: note });
                setMember(currentMember)
            }
        }
    }
    
    const deleteNote = async (noteId: string | undefined) => {
        if (noteId && currentMember) {
            var result = confirm("Are you sure you want to delete this note?")
            if (result) {
                await memberController.DeleteNoteFromMember({ NoteId: noteId });
                setMember(currentMember);
            }
        }
    }

    return (
        <div className="col-12 mx-auto">
            <h1 className="text-center">Members</h1>
            <div className="text-center">
                {membershipSummary &&
                    <span className="text-center">Total Members: {membershipSummary.MemberCount}</span>
                }
                {membershipSummary && membershipSummary.MembershipTypes.map((type) => {
                    return <span key={type.Name}><br /><span className="text-center">{type.Name}: {type.Count}</span></span>
                })}
            </div>

            <hr />
            <h3 className="text-center">Find Member</h3>
            <div className="text-center">
                {currentMember &&
                    <div>
                        <div className={`card text-dark ${currentMember.IsBlocked && "bg-danger"} ${!currentMember.IsBlocked && "bg-light"} `}>
                            <div className="card-header">
                            <span className={`${currentMember.IsBlocked && "text-light"} ${!currentMember.IsBlocked && "text-danger"} font-weight-bold`}>
                                    {currentMember.IsGuest && <strong><br />GUEST</strong>}
                                    {currentMember.IsDeleted && <strong><br />DEACTIVATED</strong>}
                                    {!currentMember.HasFingerprint && <strong><br />FINGERPRINT REQUIRED</strong>}
                                    {currentMember.IsBlocked && <strong><br />BARRED</strong>}
                                    {membershipDue(currentMember.MembershipDue) && <strong><br />MEMBERSHIP DUE</strong>}
                                </span>
                                <br />
                                <a className="btn btn-dark mx-5" href={`/editMembership/${currentMember.MembershipId}`}>Edit</a>
                                <a className="btn btn-dark" href={`/membersevents/${currentMember.Id}`} >View Attendance</a>
                            </div>
                            <div className={`card-body ${currentMember.IsGuest && "bg-warning"} ${currentMember.IsBlocked && "bg-danger"} ${currentMember.IsDeleted && "bg-danger"} ${!currentMember.HasFingerprint && "bg-success"} ${membershipDue(currentMember.MembershipDue) && "bg-primary"}`}>
                                {currentMember.Firstname} {currentMember.Surname}<br />
                                {moment(currentMember.DateOfBirth).format("DD-MM-YYYY")}<br />
                                {currentMember.MembershipType}<br />
                                {currentMember.IsSwinging && <>Swinging <br /></>}
                                {currentMember.IsFetish && <>Fetish <br /></>}
                                Current Loyalty: {currentMember.Loyalty} <br />
                                Membership Due Date: {moment(currentMember.MembershipDue).format("DD-MM-yyyy")}
                                {currentMember.AssociatedMembers && currentMember.AssociatedMembers.length > 0 && <hr />}
                                {currentMember.AssociatedMembers && currentMember.AssociatedMembers.map((member, index) => {
                                    if (member.SignedIn) {
                                        return <p key={index}><span className="text-success">&#10003;</span> {member.Name}</p>;
                                    }
                                    return <p key={index}><span className="text-danger">&#10005;</span> {member.Name}</p>;

                                })}

                            </div>
                            <div className="card-footer">
                                <button type="button" className="btn btn-dark" onClick={() => addNote(currentMember?.Id)}>Add Note</button>
                                {currentMember.Notes.length > 0 &&
                                    <table className="table">
                                        <tbody>
                                            {currentMember.Notes.map((note, index) => {
                                                return <tr key={index.toString()}>
                                                    <td className="col-3">{moment(note.Date).format("ddd DD MMM yyyy")}</td>
                                                    <td style={{ textAlign: "left" }}>{note.Note}</td>
                                                    <td><button className="btn btn-danger" onClick={() => deleteNote(note.Id)}>Delete</button></td>
                                                </tr>
                                            })}
                                        </tbody>
                                    </table>
                                }
                            </div>
                        </div>
                        <br />
                    </div>
                }
            </div>
            <hr />
            <div className="row">
                <div className="form-floating mb-3 col-6">
                    <input value={dateOfBirth} onChange={handleDateChange} type="date" className="form-control" placeholder="Date of Birth" />
                    <label htmlFor="floatingInput" className="text-dark">Date of Birth</label>
                </div>
                <div className="form-floating mb-3 col-6">
                    <input value={surname} onChange={handleSurnameChange} className="form-control" placeholder="Surname" />
                    <label htmlFor="floatingInput" className="text-dark">Surname</label>
                </div>
            </div>
            {members &&
                <div>
                    <div className="table-wrapper-scroll-y small-scrollbar">
                        <table className="table table-dark">
                            <thead>
                                <tr>
                                    <th scope="col">Firstname</th>
                                    <th scope="col">Surname</th>
                                </tr>
                            </thead>
                            <tbody>
                                {members.map((member, index) => {
                                    return <tr key={index.toString()} onClick={() => { setMember(members[index]) }}>
                                        <td>{member.Firstname}</td>
                                        <td>{member.Surname}</td>
                                    </tr>
                                })}
                            </tbody>
                        </table>
                    </div>
                </div>
            }
        </div>
    )
}